import React, { useEffect, useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import CheckCredit from "./CheckCredit/CheckCredit";
import { BarestHelpInfoApi, reqForBarestHelp } from "../../Api/ClientServices";
import { errorToast, succToast } from "./../../Toast/Toast";
import TransactionInfo from "./TransactionInfo/TransactionInfo";
import { Skeleton, Modal, Button } from "antd";

const BarestHelp = () => {
  const [loadingstate, setLoadingstate] = useState(false);
  const [transactionDataState, setTransactionDataState] = useState();
  const [checkCreditState, setCheckCreditState] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const sendRequestForBarestHelp = () => {
    setLoadingstate(true);
    reqForBarestHelp({ confirm: 0 }, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          console.log("first");
          setIsModalVisible(true);
        } else {
          errorToast(res.message);
        }
        setLoadingstate(false);
      } else {
        setLoadingstate(false);
        console.error(res);
      }
    });
  };

  const handleConfirm = () => {
    setIsModalVisible(false);
    setLoadingstate(true);
    reqForBarestHelp({ confirm: 1 }, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          succToast(res.message);
          getBarestHelpInfoHandler();
        } else {
          errorToast(res.message);
        }
        setLoadingstate(false);
      } else {
        setLoadingstate(false);
        console.error(res);
      }
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    getBarestHelpInfoHandler();
  }, []);

 const getBarestHelpInfoHandler = () => {
  setLoadingstate(true);
  BarestHelpInfoApi((succ, res) => {
    if (succ && res.status === 1) {
      const transactions = res.transactions || [];
      const hasPending = transactions.some(item => item.status === "0");
      setCheckCreditState(!hasPending);
      setTransactionDataState(transactions);
    } else {
      errorToast(res.message);
    }
    setLoadingstate(false);
  });
};

  return (
    <div
      style={{
        width: "100%",
        boxSizing: "border-box",
        padding: "3rem 1rem 1rem",
      }}
    >
      <BurgerMenuTitle title="کمک برست" />
      <Modal
        title="تایید فعال‌سازی"
        open={isModalVisible}
        onOk={handleConfirm}
        onCancel={handleCancel}
        okText="بله"
        cancelText="خیر"
        style={{ direction: "rtl", fontFamily: "iran-sans-num" }}
        closable={false}
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1.5rem",
            }}
          >
            <Button
              onClick={handleConfirm}
              style={{
                backgroundColor: "rgb(192, 0, 96)",
                color: "#fff",
                border: "none",
                width: "100px",
                height: "40px",
              }}
            >
              بله
            </Button>
            <Button onClick={handleCancel} danger>
              انصراف
            </Button>
          </div>
        }
      >
        <p style={{ fontFamily: "iran-sans-num" }}>
          شما واجد شرایط دریافت کمک براست هستید. آیا می‌خواهید فعال کنید؟
        </p>
      </Modal>

      {loadingstate && (
        <Skeleton
          active
          style={{ maxWidth: "450px", margin: "3rem auto", width: "100%" }}
        />
      )}

      {checkCreditState && (
        <CheckCredit
          sendRequest={sendRequestForBarestHelp}
          loading={loadingstate}
        />
      )}

      <TransactionInfo
        data={transactionDataState}
        updateData={getBarestHelpInfoHandler}
      />
    </div>
  );
};

export default BarestHelp;
